import { render, staticRenderFns } from "./NodeRewardWithdrawSection.vue?vue&type=template&id=4dca978e&scoped=true"
import script from "./NodeRewardWithdrawSection.vue?vue&type=script&lang=js"
export * from "./NodeRewardWithdrawSection.vue?vue&type=script&lang=js"
import style0 from "./NodeRewardWithdrawSection.vue?vue&type=style&index=0&id=4dca978e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dca978e",
  null
  
)

export default component.exports